<template>
  <div class="subject-form__reductions">
    <Loader
      v-if="isLoadingReductions"
      :bg-color="'#f6f9fc'">
    </Loader>
    <table class="do-table do-table--striped" v-else>
      <thead>
      <th></th>
      <th class="td-number td-sum">{{ totalReductionHours }}</th>
      </thead>
      <tbody>
      <tr v-if="subjectReductionsSorted.length === 0">
        <p class="pad-1 italic">Ingen reduktioner</p>
      </tr>
      <tr v-for="subjectReduction in subjectReductionsSorted"
          :key="subjectReduction.id">
        <td>
          {{ subjectReduction.vActivityTitle }} ({{ subjectReduction.vActivityReductionHours }})
        </td>
        <td class="td-number">{{ subjectReduction.vFormattedHours }}</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import Loader from '../common/Loader.vue'

export default {
  components: {Loader},
  props: {
    subject: {
      type: Object
    }
  },
  computed: {
    locale () {
      return this.$store.getters.locale
    },
    isLoadingReductions () {
      return this.$store.state.subjects.isLoadingReductions
    },
    reductionsInSubjectIdHash () {
      return this.$store.getters.reductionsInSubjectIdHash
    },
    subjectReductions () {
      return (this.reductionsInSubjectIdHash[this.subject.id] || []).map(reduction => ({
        ...reduction,
        vFormattedHours: Number(reduction.hours).toFixed(2)
      }))
    },
    subjectReductionsSorted () {
      return this.subjectReductions.sort((a, b) =>
        a.vActivityTitle.localeCompare(b.vActivityTitle, this.locale)
      )
    },
    totalReductionHours () {
      const total = this.subjectReductions.reduce((sum, reduction) => {
        return sum + Number(reduction.hours)
      }, 0)

      return total.toFixed(2)
    }
  },
  mounted () {
    const schoolId = this.subject.school_id
    const schoolYearId = this.subject.school_year_id
    this.$store.dispatch('readReductions', {schoolId, schoolYearId})
  }
}
</script>

<style scoped>
.td-number {
  text-align: right;
}

.td-sum {
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// SubjectFormReductions.vue?5efdfbcc